// Module
var code = `<!-- 4. Page frame -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Page frame</span>
    <span class="jumbotron-note">A workspace is a toolbar above a row of surfaces. The body of a surface scrolls.</span>
  </div>
  <div class="style-guide-body">
    <div class="jumbotron-page style-guide-mini">
      <div class="jumbotron-toolbar style-guide-mini-toolbar">
        <div class="jumbotron-page-heading">
          <span class="jumbotron-title style-guide-mini-title">Page</span>
          <span class="jumbotron-subtitle style-guide-mini-subtitle">The name of the object</span>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary">Action</button>
      </div>
      <div class="style-guide-mini-columns">
        <div class="jumbotron-surface style-guide-mini-surface">
          <div class="jumbotron-panel-head style-guide-mini-head">
            <span class="jumbotron-heading style-guide-mini-panel-title">Main</span>
          </div>
          <div class="jumbotron-scroll style-guide-mini-scroll">
            <p class="jumbotron-note">The body of the surface scrolls.</p>
          </div>
        </div>
        <div class="jumbotron-surface style-guide-mini-surface">
          <div class="jumbotron-panel-head style-guide-mini-head">
            <span class="jumbotron-heading style-guide-mini-panel-title">Panel</span>
          </div>
          <div class="jumbotron-scroll style-guide-mini-scroll">
            <p class="jumbotron-note">The right panel holds one object.</p>
          </div>
        </div>
      </div>
    </div>
    <p class="style-guide-caption">
      <code>.jumbotron-page</code>
      <code>.jumbotron-surface</code>
      <code>.jumbotron-toolbar</code>
      <code>.jumbotron-page-heading</code>
      <code>.jumbotron-scroll</code>
    </p>
  </div>
</div>

<!-- 5. Panel head -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Panel head</span>
    <span class="jumbotron-note">Every panel starts with this row. The name of a panel is a heading, and a kind label names only a group inside a panel.</span>
  </div>
  <div class="style-guide-body">
    <div class="jumbotron-surface">
      <div class="jumbotron-panel-head style-guide-section-head">
        <span class="jumbotron-heading">Media</span>
        <span class="jumbotron-note">14 rows</span>
        <button type="button" class="btn btn-sm btn-outline-secondary">
          <i class="fas fa-xmark" aria-hidden="true"></i> Close
        </button>
      </div>
    </div>
    <p class="style-guide-caption"><code>.jumbotron-panel-head</code></p>
  </div>
</div>

<!-- 6. Tiles -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Tiles</span>
    <span class="jumbotron-note">A tile is one number with a label above it and a note below it.</span>
  </div>
  <div class="style-guide-body">
    <div class="jumbotron-surface">
      <div class="style-guide-tiles">
        <div class="style-guide-tile">
          <span class="jumbotron-kind-label">Plays</span>
          <span class="jumbotron-tile-value style-guide-tile-value">1 284</span>
          <span class="jumbotron-note">In the window</span>
        </div>
        <div class="style-guide-tile">
          <span class="jumbotron-kind-label">Unended</span>
          <span class="jumbotron-tile-value style-guide-tile-value is-warn">12</span>
          <span class="jumbotron-note">The warn tone</span>
        </div>
        <div class="style-guide-tile">
          <span class="jumbotron-kind-label">Failed</span>
          <span class="jumbotron-tile-value style-guide-tile-value is-bad">3</span>
          <span class="jumbotron-note">The bad tone</span>
        </div>
      </div>
    </div>
    <p class="style-guide-caption">
      <code>.jumbotron-tile-value</code>
      <code>.is-warn</code>
      <code>.is-bad</code>
    </p>
  </div>
</div>

<!-- 7. Media tile -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Media tile</span>
    <span class="jumbotron-note">One tile per media in a grid that wraps. The three panels of the library draw the same tile.</span>
  </div>
  <div class="style-guide-body">
    <div class="jumbotron-media-grid">
      <div class="jumbotron-media-tile">
        <span class="jumbotron-media-tile-header style-guide-media-name">TZ_Friday</span>
        <div class="jumbotron-media-tile-content">
          <div class="jumbotron-media-tile-thumb style-guide-media-thumb" aria-hidden="true"></div>
          <div class="jumbotron-media-tile-controls">
            <button type="button" class="jumbotron-media-tile-control btn btn-sm btn-outline-primary">
              <i class="fas fa-plus" aria-hidden="true"></i> Add to playlist
            </button>
            <span class="style-guide-media-meta">
              <span><i class="far fa-clock" aria-hidden="true"></i> 0:35</span>
              <button type="button" class="btn btn-sm btn-discreet-danger" aria-label="Delete TZ_Friday">
                <i class="fas fa-trash-alt" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="jumbotron-media-tile">
        <span class="jumbotron-media-tile-header style-guide-media-name">ANDERS_Friday</span>
        <div class="jumbotron-media-tile-content">
          <div class="jumbotron-media-tile-thumb style-guide-media-thumb" aria-hidden="true"></div>
          <div class="jumbotron-media-tile-controls">
            <button type="button" class="jumbotron-media-tile-control btn btn-sm btn-outline-primary">
              <i class="fas fa-plus" aria-hidden="true"></i> Add to playlist
            </button>
            <span class="style-guide-media-meta">
              <span><i class="far fa-clock" aria-hidden="true"></i> 1:51</span>
              <button type="button" class="btn btn-sm btn-discreet-danger" aria-label="Delete ANDERS_Friday">
                <i class="fas fa-trash-alt" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <p class="style-guide-caption">
      <code>.jumbotron-media-grid</code>
      <code>.jumbotron-media-tile</code>
      <code>.jumbotron-media-tile-header</code>
      <code>.jumbotron-media-tile-content</code>
      <code>.jumbotron-media-tile-thumb</code>
      <code>.jumbotron-media-tile-controls</code>
      <code>.jumbotron-media-tile-control</code>
    </p>
  </div>
</div>

<!-- 8. Table -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Table</span>
    <span class="jumbotron-note">The head of a column is a kind label. A number column is right aligned.</span>
  </div>
  <div class="style-guide-body">
    <table class="jumbotron-table style-guide-table">
      <tr>
        <th class="jumbotron-table-head-cell">Media</th>
        <th class="jumbotron-table-head-cell jumbotron-number-cell style-guide-num">Plays</th>
        <th class="jumbotron-table-head-cell jumbotron-number-cell style-guide-num">Screen time</th>
        <th class="jumbotron-table-head-cell">Share</th>
      </tr>
      <tr class="style-guide-table-row">
        <td class="jumbotron-table-cell">TZ_Friday</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">100</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">01:00:00</td>
        <td class="jumbotron-table-cell style-guide-bar-cell">
          <span class="jumbotron-bar-track style-guide-bar">
            <span class="jumbotron-bar-fill style-guide-bar-fill" ng-style="{ width: '100%' }"></span>
          </span>
        </td>
      </tr>
      <tr class="style-guide-table-row is-selected">
        <td class="jumbotron-table-cell">Merch</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">62</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">00:37:12</td>
        <td class="jumbotron-table-cell style-guide-bar-cell">
          <span class="jumbotron-bar-track style-guide-bar">
            <span class="jumbotron-bar-fill style-guide-bar-fill" ng-style="{ width: '62%' }"></span>
          </span>
        </td>
      </tr>
      <tr class="style-guide-table-row">
        <td class="jumbotron-table-cell">Recap_Wednesday</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">20</td>
        <td class="jumbotron-table-cell jumbotron-number-cell style-guide-num">00:12:00</td>
        <td class="jumbotron-table-cell style-guide-bar-cell">
          <span class="jumbotron-bar-track style-guide-bar">
            <span class="jumbotron-bar-fill style-guide-bar-fill" ng-style="{ width: '20%' }"></span>
          </span>
        </td>
      </tr>
    </table>
    <p class="style-guide-caption">
      <code>.jumbotron-table</code>
      <code>.jumbotron-table-head-cell</code>
      <code>.jumbotron-table-cell</code>
      <code>.jumbotron-number-cell</code>
    </p>
  </div>
</div>
`;
// Exports
export default code;